import * as React from 'react';
import type { ReqGroupsState, ReqTypesState } from 'state/persisted/portal';
import type { RequestTypeSuggestion } from 'state/persisted/request-type-suggestion';
import { ExternalLinks } from 'view/external-links';
import { RecentForms } from 'view/help-center/recent-forms';
import type { CategoryListProps } from '@atlassian/help-center-common-component/category-list';
import type { FormPickerProps } from '@atlassian/help-center-common-component/form-picker';

import { ContentContainer, Root, Description, ExternalLinksListWrapper } from './styled';

interface SinglePortalProps {
    portalId: number;
    projectId: number | undefined;
    requestGroups: ReqGroupsState[];
    requestTypes: ReqTypesState[];
    requestTypeSuggestion: RequestTypeSuggestion[];
    FormPicker: React.ComponentType<FormPickerProps>;
    CategoryList: React.ComponentType<CategoryListProps>;
    description: string;
    knowledgeBaseHasCategories?: boolean;
    isEmbeddedRoute?: boolean;
}

const SinglePortal: React.StatelessComponent<SinglePortalProps> = ({
    FormPicker,
    CategoryList,
    portalId,
    projectId,
    requestTypeSuggestion,
    description,
    knowledgeBaseHasCategories,
    isEmbeddedRoute,
}) => {
    return (
        <Root>
            {!!description && <Description dangerouslySetInnerHTML={{ __html: description }} />}

            {knowledgeBaseHasCategories && (
                <ContentContainer>
                    <CategoryList cardLinkAppearance="white" portalId={portalId} isEmbeddedRoute={isEmbeddedRoute} />
                </ContentContainer>
            )}

            {!knowledgeBaseHasCategories && (
                <ContentContainer>
                    <FormPicker cardLinkAppearance="white" portalId={portalId} isEmbeddedRoute={isEmbeddedRoute} />
                </ContentContainer>
            )}

            {requestTypeSuggestion.length > 0 && (
                <RecentForms suggestedRequestTypes={requestTypeSuggestion} isEmbeddedRoute={isEmbeddedRoute} />
            )}

            {projectId && (
                <ExternalLinksListWrapper>
                    <ExternalLinks projectId={projectId} />
                </ExternalLinksListWrapper>
            )}
        </Root>
    );
};

export default SinglePortal;
